import { InputV2 } from '@southfields-digital/mpxlive-components';
import { useEffect, useState } from 'react';

type ExtendedContestantProps = {
  shortName: string;
  logoUrl?: string;
  handleChangeShortName: (name: string) => void;
};

const ExtendedContestant = ({
  shortName,
  logoUrl,
  handleChangeShortName,
}: ExtendedContestantProps) => {
  const [localValue, setLocalValue] = useState(shortName);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalValue(e.target.value);
    handleChangeShortName(e.target.value);
  };

  useEffect(() => {
    setLocalValue(shortName);
  }, [shortName]);

  return (
    <div className="flex flex-col w-full min-w-0 gap-2 justify-between">
      <div className="w-full flex justify-center align-center aspect-square p-2 bg-elevated-2">
        <img className="object-contain w-full h-full" src={logoUrl} />
      </div>

      <InputV2
        type="text"
        inputSize="lg"
        className="text-center text-lg w-full min-w-0"
        value={localValue}
        onChange={handleChange}
      />
    </div>
  );
};

export default ExtendedContestant;
